import { request } from "./http";
import { API_BASE_URL } from "./config";

export function pingDb() {
    var url = API_BASE_URL + "/api/health/db";
    return fetch(url, {
        method: "GET",
        headers: { Accept: "text/plain, */*" }
    }).then(function (r) {
        if (!r.ok) throw new Error("Health DB " + r.status);
        return r.text(); // "OK" napr.
    });
}